module.exports = __webpack_public_path__ + "img/upload.3c0f86bf.svg";